/* eslint-disable react/prop-types */
import Loading from "components/Loading";
import ModalUI from "components/ModalUI";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { getGhollaks } from "services/ghollak.routes";
import queryString from "utils/queryString";
import GhollakTable from "./GhollakTable";
import { toast } from "react-toastify";

export default function InvestorGhollaksModal({ modalInfo, closeModal }) {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [ghollaks, setGhollaks] = useState([]);

    useEffect(() => {
        if (modalInfo.userId) {
            setLoading(true);
            const query = {
                cursor: cursor === null ? null : cursor,
                user_id: modalInfo.userId,
                admin: 1,
                all: 1,
            }
            getGhollaks(queryString(query), false, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message)
                } else {
                    if (page !== 0) {
                        setGhollaks((prev) => ([...prev, ...data.data]));
                    } else {
                        setGhollaks(data.data);
                    }
                    setLoading(false);
                    setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                    setHasMore(data.meta.next_cursor !== null);
                }
            })
        }

    }, [modalInfo.investorId, page])

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }

    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
            <Loading loading={loading} />
            {ghollaks.length === 0 ? <p style={{ fontSize: 16 }}>کاربر قلکی ندارد!</p> : <InfiniteScroll dataLength={ghollaks.length} next={fetchMoreData} hasMore={hasMore}>
                <GhollakTable data={ghollaks} setGhollaks={setGhollaks} />
            </InfiniteScroll>}
        </ModalUI>
    )
}